/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

const form = {
  formId: "new-product-form",
  formField: {
    name: {
      name: "name",
      label: "Nombre",
      type: "text",
      errorMsg: "El nombre es obligatorio.",
    },
    formula: {
      name: "formula",
      label: "Fórmula",
      type: "text",
      errorMsg: "La fórmula es obligatorio.",
    },
    description: {
      name: "description",
      label: "Descripción",
      type: "text",
      multiline: true,
      rows: 2
    },
    brand: {
      name: "brand",
      label: "Marca",
      type: "text",
      errorMsg: "La marca es obligatoria.",
    },
    price: {
      name: "price",
      label: "Precio de Venta",
      type: "number",
      errorMsg: "El precio de venta es obligatorio.",
      invalidMsg: "Debe ser mayor a 0",
      min: 0
    },
    cost: {
      name: "cost",
      label: "Costo",
      type: "number",
      errorMsg: "El costo es obligatorio.",
      invalidMsg: "Debe ser mayor a 0",
      min: 0
    },
    fee_percent: {
      name: "fee_percent",
      label: "Porcentaje de Comisión",
      type: "number",
      errorMsg: "El porcentaje de comisión es obligatorio.",
      invalidMsg: "Debe ser mayor a 0",
      min: 0
    },
    discount_percent: {
      name: "discount_percent",
      label: "Porcentaje de Descuento",
      type: "number",
      errorMsg: "El porcentaje de descuento es obligatorio.",
      invalidMsg: "Debe ser mayor a 0",
      min: 0
    },
    image_name: {
      name: "image_name",
      label: "Imagen",
      type: "file",
      accept: {
          'image/png': ['.png'],
          'image/jpg': ['.jpg'],
          'image/jpeg': ['.jpeg'],
      },
      fileType: "image"
    },
  },
};

export default form;
